import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RemoverAlertasService {
    public removerTodosClick = 0;

    public removerTodos() {
        this.removerTodosClick++;
    }
}